import carAndHomeContent from './car-and-home';
import lifeAndIncomeContent from './life-and-income';
import petContent from './pet';

const CONTENT = {
  car: carAndHomeContent,
  home: carAndHomeContent,
  'income-protection': lifeAndIncomeContent,
  life: lifeAndIncomeContent,
  pet: petContent,
};

export default CONTENT;
